import React from 'react'
import styled from 'styled-components'
import { Typewriter } from 'react-simple-typewriter'

const HeroSection = () => {
  return (
    <>
      <Wrapper>
        <div className="container">

          {/* Header Section  */}
            <div className="header">
                <div className="logo">
                    <img src="./Images/logo.png" alt="logo" width={130}/>
                </div>
                <div className="resume">
                    <a href="./Images/Arslan_Resume.pdf" download>Download Resume</a>
                </div>
            </div>

          {/* Hero Data  */}

           <div className="hero_data">
          <h1 style={{ color:"white", fontWeight: 'normal',textAlign:"center",fontSize:"20px" }}>
        HELLO I'M
        <br/>
        {' '}
        <span style={{ color: 'rgba(255, 204, 0, 1)', fontWeight: 'bold' }}>
          {/* Style will be inherited from the parent element */}
          <Typewriter
            words={['MD. Arslan', 'Front-end Developer', 'UI / UX Designer']}
            loop={100}
            cursor
            cursorStyle='|'
            typeSpeed={70}
            deleteSpeed={50}
            delaySpeed={1000}/>
        </span>
      </h1>
      <div className="details">
        <p>With 2+ years of React.js experience, I've crafted dynamic and responsive user interfaces, proficiently integrating RESTful APIs, state management, and performance optimization to deliver engaging web applications while staying current with industry trends and best practices.</p>
      </div>

      {/* Mouse Wheel  */}

      <div className="scroll-icon ex-1">
    <span className="wheel"></span>
   </div>
      </div>




        </div>
      <div className="line"></div>
      </Wrapper>
    </>
  )
}

export default HeroSection


const Wrapper = styled.section`
.container{
    width: 100%;
    height: 100vh;
    background-image: url("./Images/homePage2.png");
    background-position: center;
    background-size: cover;
    /* background-attachment:fixed; */
    padding-left: 5%;
    padding-right: 5%;
}
.header{
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* margin-left: 5%;
  margin-right: 5%; */
  padding-top: 2%;
}
.resume a{
  color: rgba(255, 204, 0, 1);
  text-decoration: none;
  border: 2px solid rgba(255, 204, 0, 1);
  padding: 10px 20px;
  border-radius: 65px;
  transition: 0.8s;
}
.resume a:hover{
  background-color: rgba(255, 204, 0, 1);
  color: white;
}
.hero_data{
  width: 100%;
  height: 75vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
}

.hero_data h1 span{
  font-size: 43px;
  position: relative;
  top: 5px;
  color: rgba(255, 204, 0, 1);
}
.details p{
  width: 60vw;
  padding-top: 40px;
}
.line{
  width: 100%;
  height: 1px;
  background-color:  rgba(67, 67, 67, 1);
}


.scroll-icon{
            width: 2em;
            height: 3.5em;
            border: .2em solid white;
            border-radius: 2em;
            position: relative;
            position: absolute;
            bottom: 0px;
        }
        .scroll-icon.ex-1 .wheel{
            position: absolute;
            width: 0.5em;
            height: 0.5em;
            background-color: white;
            left: 50%;
            top: 15%;
            transform: translate(-50%, 0);
            border-radius: 2em;
            animation: upDown 1s ease-in-out infinite;
        }
        @keyframes upDown {
            0%{
                transform: translate(-50%, 0);
                opacity: 0;
            }
            20%,70%{
                opacity: 1;
            }
            90%, 100%{
                transform: translate(-50%, 150%);
                opacity: 0;
            }
            
        }
@media (max-width: 768px) {
  .logo img{
    width: 100px;
  }
  .resume a{
    font-size: 14px;
  }
  .hero_data h1{
    font-size: 16px;
  }
  .hero_data h1 span{
    font-size: 30px;
  }
  .details p{
    width: 90vw;
    font-size: 16px;
  }
  .scroll-icon{
    display: none;
  }
  .container{
    background-attachment:scroll;
}
}
`